var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"static-page page container-padding"},[(_vm.data.title)?_c('h1',[_vm._v(_vm._s(_vm.data.title))]):_vm._e(),_c('div',{staticClass:"static-page__content"},[_c('EditorJSComponent',{attrs:{"text":_vm.data.description}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }